import React from 'react';

const Home = () => (
  <div className="home">
    <h2 className="heading">Welcome to Our Page!</h2>
    <p className="paragraph">
      Math Magic Calculator is a versatile and powerful tool that can handle
      wide range of mathematical operations with ease. Its user-friendly
      interface and intuitive design make it an ideal choice for students,
      teachers, engineers, and anyone who needs to perform mathematical
      calculations on a regular basis. The calculator can perform basic
      arithmetic operations, as well as more complex operations such as
      logarithms, trigonometric functions, and calculus. It is also flexible in
      the way it accepts input, allowing users to input expressions in standard
      notation or through spoken commands. Additionally, it can store and recall
      previous calculations, making it easy to review and reuse results.
      <br />
      Overall, Math Magic Calculator is an indispensable tool for anyone who
      needs to work with numbers. Its powerful features and intuitive design
      make it easy to use and highly efficient.
    </p>
  </div>
);

export default Home;
